"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FalconPropositionEngineImpl = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const core_1 = require("@athena-portal/core");
const Types_1 = require("../../Types");
const Cache_1 = require("../../decorators/Cache");
const EnumPolicyFilter_1 = require("./EnumPolicyFilter");
let FalconPropositionEngineImpl = class FalconPropositionEngineImpl extends core_1.RestService {
    constructor(configuration, notificationService) {
        super();
        this.configuration = configuration;
        this.authMandatory = false;
        if (this.configuration.authMandatory !== undefined) {
            this.authMandatory = this.configuration.authMandatory;
        }
        this.notificationService = notificationService;
    }
    cloneInteraction(interactionId) {
        const url = `${this.configuration.serviceBaseUrl}/products/interaction/${interactionId}/clone`;
        return super.getProtectedResource({
            url,
            method: "POST",
            withCredentials: true,
            headers: this.configuration.customHeaders
        }, this.configuration.customQueryStringParameters, this.authMandatory).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(err => {
            console.error("Caught 'FalconPropositionEngineImpl' service API response error", err);
            return (0, rxjs_1.of)(null);
        }));
    }
    fetchInteractionForSurnameAndDateOfBirthAndCarRegAndPostcodeAndStatus(lastName, dateOfBirth, registrationNumber, postcode, status) {
        const formattedRegistrationNumber = registrationNumber.replace(/\s+/g, "").toUpperCase();
        const formattedPostcode = postcode.replace(/\s+/g, "").toUpperCase();
        const url = `${this.configuration.serviceBaseUrl}/products/interaction?lastName=${lastName}&dateOfBirth=${dateOfBirth}&registrationNumber=${formattedRegistrationNumber}&postcode=${formattedPostcode}&status=${status}`;
        return super.getProtectedResource({
            url,
            withCredentials: true,
            headers: this.configuration.customHeaders
        }, this.configuration.customQueryStringParameters, this.authMandatory).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(err => {
            console.error("Caught 'FalconPropositionEngineImpl' service API response error", err);
            return (0, rxjs_1.of)(null);
        }));
    }
    fetchInteractionByEmailAndDob(product, id, email, dateOfBirth) {
        const url = `${this.configuration.serviceBaseUrl}/products/${product}/interaction/${id}?email=${email}&dob=${dateOfBirth}`;
        return super.getProtectedResource({
            url,
            withCredentials: true,
            headers: this.configuration.customHeaders
        }, this.configuration.customQueryStringParameters, this.authMandatory).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(err => {
            console.error("Caught 'FalconPropositionEngineImpl' service API response error", err);
            return (0, rxjs_1.of)(null);
        }));
    }
    fetchJourneyByInteractionEmailAndDob(product, process, id, languageCode, email, dateOfBirth) {
        const url = `${this.configuration.serviceBaseUrl}/products/${product}/process/${process}/interaction/${id}/language/${languageCode}?email=${email}&dob=${dateOfBirth}`;
        return super.getProtectedResource({
            url,
            withCredentials: true,
            headers: this.configuration.customHeaders
        }, this.configuration.customQueryStringParameters, this.authMandatory).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(err => {
            console.error("Caught 'FalconPropositionEngineImpl' service API response error", err);
            return (0, rxjs_1.of)(null);
        }));
    }
    fetchSessionInformation() {
        const url = `${this.configuration.serviceBaseUrl}/session`;
        return super.getProtectedResource({
            url,
            withCredentials: true,
            headers: this.configuration.customHeaders
        }, this.configuration.customQueryStringParameters, this.authMandatory).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(() => {
            this.notificationService.push({
                level: "ERROR",
                message: "We are experiencing some technical issues, please come back later"
            });
            return (0, rxjs_1.of)({});
        }));
    }
    fetchInteractionByToken(token) {
        const url = `${this.configuration.serviceBaseUrl}/startJourney/${token}`;
        return super.getProtectedResource({
            url,
            withCredentials: true,
            headers: this.configuration.customHeaders
        }, this.configuration.customQueryStringParameters, this.authMandatory);
    }
    fetchStatusByInteractionId(id) {
        const url = `${this.configuration.serviceBaseUrl}/products/interactionStatus/${id}`;
        return super.getProtectedResource({
            url,
            withCredentials: true,
            headers: this.configuration.customHeaders
        }, this.configuration.customQueryStringParameters, this.authMandatory).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(err => {
            console.error("Caught 'FalconPropositionEngineImpl' service API response error", err);
            return (0, rxjs_1.throwError)(() => err);
        }));
    }
    getInstalmentsInfo(agreementNumber, filterMtc) {
        const url = `${this.configuration.serviceBaseUrl}/policies/${agreementNumber}/payment/instalmentsInfo?filterMtc=${filterMtc}`;
        return super.getProtectedResource({
            url,
            headers: this.configuration.customHeaders,
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(err => {
            this.notificationService.push({
                level: "ERROR",
                message: "We are experiencing some technical issues, please come back later"
            });
            return (0, rxjs_1.throwError)(err);
        }));
    }
    getPartyPropertyByPropertyKey(propertyKey) {
        const url = `${this.configuration.serviceBaseUrl}/profile/property/${propertyKey}`;
        return super.getProtectedResource({
            url,
            headers: this.configuration.customHeaders,
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(err => {
            this.notificationService.push({
                level: "ERROR",
                message: "We are experiencing some technical issues, please come back later"
            });
            return (0, rxjs_1.throwError)(err);
        }));
    }
    getPolicies(filter, onlyCurrentPeriodPolicyVersions = false) {
        const searchParams = new URLSearchParams();
        if (filter) {
            searchParams.append("filter", EnumPolicyFilter_1.EnumPolicyFilter[filter]);
        }
        searchParams.append("onlyCurrentPeriodPolicyVersions", onlyCurrentPeriodPolicyVersions.toString());
        const url = `${this.configuration.serviceBaseUrl}/policies?${searchParams.toString()}`;
        return super.getProtectedResource({
            url,
            headers: this.configuration.customHeaders,
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(err => {
            this.notificationService.push({
                level: "ERROR",
                message: "We are experiencing some technical issues, please come back later"
            });
            return (0, rxjs_1.throwError)(err);
        }));
    }
    getPolicyInteraction(policyNumber) {
        const url = `${this.configuration.serviceBaseUrl}/agreement/interaction/${policyNumber}`;
        return super.getProtectedResource({
            url,
            headers: this.configuration.customHeaders,
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(err => {
            this.notificationService.push({
                level: "ERROR",
                message: "We are experiencing some technical issues, please come back later"
            });
            return (0, rxjs_1.throwError)(err);
        }));
    }
    getProfile() {
        const url = `${this.configuration.serviceBaseUrl}/profile`;
        return super.getProtectedResource({
            url,
            headers: this.configuration.customHeaders,
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(err => {
            this.notificationService.push({
                level: "ERROR",
                message: "We are experiencing some technical issues, please come back later"
            });
            return (0, rxjs_1.throwError)(err);
        }));
    }
    getUserById() {
        const url = `${this.configuration.serviceBaseUrl}/profile/party`;
        return super.getProtectedResource({
            url,
            headers: this.configuration.customHeaders,
        }, this.configuration.customQueryStringParameters).pipe((0, operators_1.map)((response) => {
            return response.response;
        }), (0, operators_1.catchError)(err => {
            this.notificationService.push({
                level: "ERROR",
                message: "We are experiencing some technical issues, please come back later"
            });
            return (0, rxjs_1.throwError)(err);
        }));
    }
};
exports.FalconPropositionEngineImpl = FalconPropositionEngineImpl;
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, Boolean]),
    __metadata("design:returntype", rxjs_1.Observable)
], FalconPropositionEngineImpl.prototype, "getInstalmentsInfo", null);
__decorate([
    (0, Cache_1.ClearCache)("getProfile"),
    (0, Cache_1.ClearCache)("getUserById"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], FalconPropositionEngineImpl.prototype, "getPartyPropertyByPropertyKey", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number, Boolean]),
    __metadata("design:returntype", rxjs_1.Observable)
], FalconPropositionEngineImpl.prototype, "getPolicies", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", rxjs_1.Observable)
], FalconPropositionEngineImpl.prototype, "getPolicyInteraction", null);
__decorate([
    (0, Cache_1.CacheObservable)(true),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", rxjs_1.Observable)
], FalconPropositionEngineImpl.prototype, "getProfile", null);
exports.FalconPropositionEngineImpl = FalconPropositionEngineImpl = __decorate([
    (0, core_1.injectable)(),
    __param(0, (0, core_1.inject)(Types_1.Types.RuntimeServiceConfig)),
    __param(1, (0, core_1.inject)(Types_1.Types.NotificationService)),
    __metadata("design:paramtypes", [Object, Object])
], FalconPropositionEngineImpl);
//# sourceMappingURL=FalconPropositionEngineImpl.js.map